module.exports = __webpack_public_path__ + "img/CustomFields-2.02ddb0f9.png";